import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { fonts } from './fonts.js';
import { colors } from './colors.js';
import { Themes } from '../theme.types.js';
import neutral from '../neutral/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var inputSelectedOutline = colors.accessoryBlue;
var inputOutline = colors.warmLightGrey2;
var inputBackgroundColor = colors.white;
var defaultLetterSpacing = 'normal';
var sokosHotelsCornerRadius = '3px';
var primaryBoxShadow = '0px 1px 4px rgba(0, 0, 0, 0.15)';
var defaultFonts = {
  family: fonts.GothamSSm.fontFamily,
  sizeSmall: fonts.GothamSSm.sizes.xxs,
  sizeMiddle: fonts.GothamSSm.sizes.xs,
  sizeLarge: fonts.GothamSSm.sizes.s
};
var fontSettings = {
  fontVariant: 'normal',
  fontFeatureSettings: 'normal'
};
var components = {
  name: Themes.SOKOS_HOTELS,
  accordion: {
    fontFamily: fonts.GothamSSm.fontFamily,
    fontSize: fonts.GothamSSm.sizes.s.fontSize,
    fontWeightTitle: fonts.GothamSSm.weights.medium,
    fontWeightContent: fonts.GothamSSm.weights.book,
    lineHeight: fonts.GothamSSm.sizes.s.lineHeight,
    "default": _objectSpread(_objectSpread({}, neutral.components.accordion["default"]), {}, {
      focusColor: colors.primaryDark
    }),
    filled: _objectSpread({}, neutral.components.accordion.filled),
    darkMode: _objectSpread({}, neutral.components.accordion.darkMode)
  },
  alert: _objectSpread(_objectSpread({}, neutral.components.alert), {}, {
    fontFamily: fonts.GothamSSm.fontFamily,
    fontSize: fonts.GothamSSm.sizes.xs.fontSize
  }),
  button: {
    fonts: defaultFonts,
    focusColor: colors.accessoryBlue,
    keyboardOnlyFocusOutline: colors.accessoryBlue,
    letterSpacing: defaultLetterSpacing,
    borderRadius: sokosHotelsCornerRadius,
    fontWeight: fonts.GothamSSm.weights.medium,
    fontWeightRegular: fonts.GothamSSm.weights.book,
    primary: _objectSpread(_objectSpread({}, neutral.components.button.primary), {}, {
      background: "linear-gradient(180deg, ".concat(colors.primary, " 0%, ").concat(colors.primaryDark, " 100%)"),
      color: colors.white,
      focusBackground: colors.primaryDark,
      activeBackground: colors.primaryDark,
      hoverBackground: colors.primaryDark,
      // how this should be done?
      disabledBackground: colors.primaryLight,
      disabledColor: colors.white,
      boxShadow: primaryBoxShadow
    }),
    secondary: _objectSpread(_objectSpread({}, neutral.components.button.secondary), {}, {
      background: colors.warmLightGrey1,
      hoverBackground: colors.warmLightGrey2,
      disabledBackground: colors.secondaryLight,
      color: colors.black,
      disabledColor: colors.lightGray,
      smallColor: colors.charcoal
    }),
    "default": {
      color: colors.charcoal,
      disabledColor: colors.grey400,
      borderColor: colors.charcoal,
      hoverColor: colors.white,
      hoverBorderColor: colors.charcoal,
      hoverBackgroundColor: colors.charcoal
    },
    link: _objectSpread(_objectSpread({}, neutral.components.button.link), {}, {
      color: colors.primary,
      hoverColor: colors.primaryLight,
      disabledColor: colors.primaryLight
    }),
    text: {
      color: colors.primary,
      hoverColor: colors.primaryDark,
      disabledColor: colors.primaryLight
    }
  },
  // TODO: make some sense out of this
  checkbox: {
    fonts: _objectSpread(_objectSpread({}, defaultFonts), {}, {
      sizeSmall: fonts.GothamSSm.sizes.xs,
      sizeLarge: fonts.GothamSSm.sizes.xs
    }),
    // @todo sizes have changed since before
    borderColor: inputOutline,
    // actually ALSO the color of border while hovering, and ALSO the color of border while focused
    checkedBorderColor: inputOutline,
    // does not have any effect?
    disabledBorderColor: inputOutline,
    checkedBackgroundColor: inputBackgroundColor,
    // actually hover checked BACKGROUND-color
    hoverCheckedBorderColor: inputSelectedOutline,
    tickColor: colors.charcoal,
    hoverCheckedBackgroundColor: inputBackgroundColor,
    hoverBorderColor: inputSelectedOutline,
    keyboardFocusBorderColor: inputSelectedOutline,
    smallSize: fonts.GothamSSm.sizes.xxxs.lineHeight,
    largeSize: fonts.GothamSSm.sizes.m.lineHeight
  },
  // TODO: Theming has to be done in the design-system consumer side
  datePicker: _objectSpread(_objectSpread({}, fontSettings), {}, {
    fontFamily: fonts.GothamSSm.fontFamily,
    fontSizeSmall: fonts.GothamSSm.sizes.xxs,
    fontSizeMiddle: fonts.GothamSSm.sizes.xs,
    fontSizeLarge: fonts.GothamSSm.sizes.s,
    fontWeight: fonts.GothamSSm.weights.bold,
    color: colors.charcoal,
    hoverColor: inputSelectedOutline,
    borderColor: inputOutline,
    borderFocusColor: inputSelectedOutline,
    highlightColor: colors.accessoryBlue,
    highlightFocusColor: colors.accessoryBlueDark,
    fontSizeDropdown: fonts.GothamSSm.sizes.xxs
  }),
  drawer: {
    fontFamily: fonts.GothamSSm.fontFamily,
    defaultFontSize: fonts.GothamSSm.sizes.m,
    focusColor: colors.accessoryBlue
  },
  form: _objectSpread(_objectSpread({}, neutral.components.form), {}, {
    labelFontSize: fonts.GothamSSm.sizes.s.fontSize,
    helpTextFontSize: fonts.GothamSSm.sizes.xs.fontSize,
    helpErrorColor: colors.error,
    helpInfoColor: colors.black
  }),
  grid: _objectSpread({}, neutral.components.grid),
  input: _objectSpread(_objectSpread(_objectSpread({}, neutral.components.input), fontSettings), {}, {
    inputBackgroundColor: colors.white,
    fontFamily: fonts.GothamSSm.fontFamily,
    letterSpacing: defaultLetterSpacing,
    textColor: colors.charcoal,
    highlightHoverColor: inputSelectedOutline,
    highlightFocusColor: inputSelectedOutline,
    fontWeight: fonts.GothamSSm.weights.bold,
    errorColor: colors.error
  }),
  modal: _objectSpread(_objectSpread({}, neutral.components.modal), {}, {
    fontFamily: fonts.GothamSSm.fontFamily,
    titleFontSize: fonts.GothamSSm.sizes.l,
    titleFontWeight: fonts.GothamSSm.weights.bold,
    titleColor: colors.charcoal
  }),
  popover: {
    fontFamily: fonts.GothamSSm.fontFamily,
    defaultFontSize: fonts.GothamSSm.sizes.s
  },
  // TODO: focus outline for currently focused menu item
  select: _objectSpread(_objectSpread(_objectSpread({}, neutral.components.select), fontSettings), {}, {
    fontFamily: fonts.GothamSSm.fontFamily,
    color: colors.charcoal,
    borderColor: "1px solid ".concat(inputOutline),
    borderFocusColor: inputSelectedOutline,
    hoverItemBgColor: colors.accessoryBlueLight,
    selectedItemBgColor: colors.accessoryBlueLight,
    fontSizeSmall: fonts.GothamSSm.sizes.xxs,
    fontSizeMiddle: fonts.GothamSSm.sizes.xs,
    fontSizeLarge: fonts.GothamSSm.sizes.xs,
    fontWeight: fonts.GothamSSm.weights.bold,
    fontWeightSelected: fonts.GothamSSm.weights.bold,
    selectDropdownFont: fonts.GothamSSm.sizes.xs
  }),
  "switch": {
    fontFamily: fonts.GothamSSm.fontFamily,
    fontSizeMiddle: fonts.GothamSSm.sizes.s,
    fontSizeSmall: fonts.GothamSSm.sizes.s,
    color: colors.charcoal,
    fontWeight: fonts.GothamSSm.weights.medium,
    offBackgroundColor: colors.warmMediumGrey,
    offBackgroundColorDisabled: colors.lightGray,
    offBackgroundColorHover: colors.charcoal,
    onBackgroundColor: colors.primary,
    onBackgroundColorDisabled: colors.primaryLight,
    onBackgroundColorHover: colors.primaryDark,
    focusColor: colors.primary
  },
  radio: {
    fontFamily: fonts.GothamSSm.fontFamily,
    fontSize: fonts.GothamSSm.sizes.s.fontSize,
    color: colors.charcoal,
    borderColor: inputOutline,
    checkedBorderColor: inputOutline,
    checkedDotColor: colors.charcoal,
    focusColor: inputSelectedOutline,
    keyboardOnlyFocusColor: inputSelectedOutline,
    hoverColor: inputSelectedOutline,
    shadowColor: inputSelectedOutline,
    disabledColor: inputOutline
  },
  tab: _objectSpread(_objectSpread({}, neutral.components.tab), {}, {
    color: colors.grey,
    focusColor: colors.primary,
    hoverColor: colors.primaryDark,
    defaultTabColor: colors.grey800,
    defaultDisabledTabColor: colors.grey400
  }),
  tag: _objectSpread({}, neutral.components.tag)
};

export { components };
//# sourceMappingURL=components.js.map
